export default __webpack_public_path__ + "static/media/slide-network.27e14c26.mp3";